import { Route, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import NavBar from "./components/nav/NavBar";
import Drawer from "./components/nav/Drawer";
import Footer from "./components/nav/Footer";
import utils from "./utils";
import { Toaster } from "react-hot-toast";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PolicyPage from "./pages/PolicyPage";
import RefundPage from "./pages/RefundPage";
import ScrollToTop from "./components/nav/ScrollToTop";
import LoginPage from "./pages/auth/LoginPage";
import RegisterPage from "./pages/auth/RegisterPage";
import ProfilePgae from "./pages/auth/ProfilePgae";
import AccessPage from "./pages/auth/AccessPage";
import OrdersPage from "./pages/auth/OrdersPage";
import AddressPage from "./pages/auth/AddressPage";
import ForgotPassword from "./pages/auth/ForgotPassword";
import CartPage from "./pages/cart/CartPage";
import CheckoutPage from "./pages/cart/CheckoutPage";
import AdminDashBoard from "./pages/dashboard/AdminDashBoard";
import VendorDashBoard from "./pages/dashboard/VendorDashBoard";
import CategoriesPage from "./pages/products/CategoriesPage";
import ProductsListPage from "./pages/products/ProductsListPage";
import ProductView from "./pages/products/ProductView";
import SessionInitializer from "./components/nav/SessionInit";
import CheckoutComplete from "./pages/cart/CheckoutComplete";
import PaymentsnBillingPage from "./pages/PaymentsnBillingPage";
import TermsPage from "./pages/TermsPage";
import ProtectedRoutes from "./LoggedInReroutes";
import CookiesNotice from "./pages/CookiesNotice";
import PageNotFound from "./pages/PageNotFound";
import UserPaymentConfirmPage from "./pages/cart/UserPaymentConfirmPage";
import DeliveryConfirmationPage from "./pages/cart/DeliveryConfirmationPage";

function App(props) {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (args[0]?.includes("findDOMNode")) return;
    originalConsoleError.apply(console, args);
  };
  return (
    <div className="App">
      <ScrollToTop />
      <SessionInitializer />
      <div className="drawer drawer-end">
        <input id="nav-drawer" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content">
          <NavBar />
          <div id="nav-top" className=""></div>
          <div className="page">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/policy" element={<PolicyPage />} />
              <Route path="/refund" element={<RefundPage />} />
              <Route path="/billings" element={<PaymentsnBillingPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/cookies" element={<CookiesNotice />} />

              <Route path="/auth/login" element={<LoginPage />} />
              <Route path="/auth/register" element={<RegisterPage />} />
              <Route path="/auth/forgot" element={<ForgotPassword />} />

              <Route
                path="/auth/profile"
                element={
                  <ProtectedRoutes>
                    <ProfilePgae />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/auth/access"
                element={
                  <ProtectedRoutes>
                    <AccessPage />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/auth/orders"
                element={
                  <ProtectedRoutes>
                    <OrdersPage />
                  </ProtectedRoutes>
                }
              />
              <Route path="/auth/address" element={<AddressPage />} />

              <Route path="/cart" element={<CartPage />} />
              <Route path="/cart/checkout" element={<CheckoutPage />} />

              <Route path="/payment/usr/track/:txRef/order/view" element={<UserPaymentConfirmPage />} />
              <Route path="/payment/:txRef/delivery/confirm" element={<DeliveryConfirmationPage />} />

              <Route
                path="/cart/checkout/complete"
                element={<CheckoutComplete />}
              />

              <Route
                path="/dashboard/admin"
                element={
                  <ProtectedRoutes>
                    <AdminDashBoard />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/dashboard/vendor"
                element={
                  <ProtectedRoutes>
                    <VendorDashBoard />
                  </ProtectedRoutes>
                }
              />

              <Route path="/product/:slug" element={<ProductView />} />
              <Route path="/products" element={<ProductsListPage />} />
              <Route path="/categories" element={<CategoriesPage />} />

              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </div>

          <Footer />
          <Toaster
            position={utils.toasterPosition}
            toastOptions={utils.toasterOptions}
          />
        </div>
        <Drawer />
      </div>
    </div>
  );
}

export default App;
